 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"about-about-module":"about-about-module","agreement-agreement-module":"agreement-agreement-module","apiconfig-apiconfig-module":"apiconfig-apiconfig-module","apiconfigop-apiconfigop-module":"apiconfigop-apiconfigop-module","assets-assets-module":"assets-assets-module","astock-apiconfig-apiconfig-module":"astock-apiconfig-apiconfig-module","astock-apiconfigop-apiconfigop-module":"astock-apiconfigop-apiconfigop-module","astock-astockbalance-astockbalance-module":"astock-astockbalance-astockbalance-module","astock-astockcoordinatorop-astockcoordinatorop-module":"astock-astockcoordinatorop-astockcoordinatorop-module","astock-astockposition-astockposition-module":"astock-astockposition-astockposition-module","astock-astockruleop-astockruleop-module":"astock-astockruleop-astockruleop-module","astock-astockrules-astockrules-module":"astock-astockrules-astockrules-module","astock-astocktemplate-astocktemplate-module":"astock-astocktemplate-astocktemplate-module","astock-astocktemplateop-astocktemplateop-module":"astock-astocktemplateop-astocktemplateop-module","astock-productlist-productlist-module":"astock-productlist-productlist-module","authinfo-authinfo-module":"authinfo-authinfo-module","backup-spotbackup-spotbackup-module":"backup-spotbackup-spotbackup-module","baseconfig-baseconfig-module":"baseconfig-baseconfig-module","coinconfig-coinconfig-module":"coinconfig-coinconfig-module","common":"common","core-js-js":"core-js-js","css-shim-206ea950-3169f23e-js":"css-shim-206ea950-3169f23e-js","ctp-apiconfig-apiconfig-module":"ctp-apiconfig-apiconfig-module","ctp-apiconfigop-apiconfigop-module":"ctp-apiconfigop-apiconfigop-module","ctp-ctpbalance-ctpbalance-module":"ctp-ctpbalance-ctpbalance-module","ctp-ctphedgingposition-ctphedgingposition-module":"ctp-ctphedgingposition-ctphedgingposition-module","ctp-ctphedgingprice-ctphedgingprice-module":"ctp-ctphedgingprice-ctphedgingprice-module","ctp-ctphedgingruleop-ctphedgingruleop-module":"ctp-ctphedgingruleop-ctphedgingruleop-module","ctp-ctphedgingrules-ctphedgingrules-module":"ctp-ctphedgingrules-ctphedgingrules-module","ctp-ctphedgingtemplate-ctphedgingtemplate-module":"ctp-ctphedgingtemplate-ctphedgingtemplate-module","ctp-ctphedgingtemplateop-ctphedgingtemplateop-module":"ctp-ctphedgingtemplateop-ctphedgingtemplateop-module","ctp-ctpposition-ctpposition-module":"ctp-ctpposition-ctpposition-module","ctp-ctpruleop-ctpruleop-module":"ctp-ctpruleop-ctpruleop-module","ctp-ctprules-ctprules-module":"ctp-ctprules-ctprules-module","ctp-ctptemplate-ctptemplate-module":"ctp-ctptemplate-ctptemplate-module","ctp-ctptemplateop-ctptemplateop-module":"ctp-ctptemplateop-ctptemplateop-module","ctp-productlist-productlist-module":"ctp-productlist-productlist-module","dom-96781eef-a2fb04dd-js":"dom-96781eef-a2fb04dd-js","dom-js":"dom-js","exchangeconfig-exchangeconfig-module":"exchangeconfig-exchangeconfig-module","exchangeconfigop-exchangeconfigop-module":"exchangeconfigop-exchangeconfigop-module","feesolutionconfig-feesolutionconfig-module":"feesolutionconfig-feesolutionconfig-module","feesolutionconfigop-feesolutionconfigop-module":"feesolutionconfigop-feesolutionconfigop-module","fhedgingruleop-fhedgingruleop-module":"fhedgingruleop-fhedgingruleop-module","fhedgings-fhedgings-module":"fhedgings-fhedgings-module","fhedgingtemplate-fhedgingtemplate-module":"fhedgingtemplate-fhedgingtemplate-module","fhedgingtemplateop-fhedgingtemplateop-module":"fhedgingtemplateop-fhedgingtemplateop-module","forex-currencies-forex-currencies-module":"forex-currencies-forex-currencies-module","forex-currency-op-forex-currency-op-module":"forex-currency-op-forex-currency-op-module","fprice-fprice-module":"fprice-fprice-module","futurecoordinatorop-futurecoordinatorop-module":"futurecoordinatorop-futurecoordinatorop-module","futuredriveruleop-futuredriveruleop-module":"futuredriveruleop-futuredriveruleop-module","futuredriverules-futuredriverules-module":"futuredriverules-futuredriverules-module","futureposition-futureposition-module":"futureposition-futureposition-module","futureruleop-futureruleop-module":"futureruleop-futureruleop-module","futures-futures-module":"futures-futures-module","futuretemplate-futuretemplate-module":"futuretemplate-futuretemplate-module","futuretemplateop-futuretemplateop-module":"futuretemplateop-futuretemplateop-module","hedgingruleop-hedgingruleop-module":"hedgingruleop-hedgingruleop-module","hedgings-hedgings-module":"hedgings-hedgings-module","index-69c37885-js":"index-69c37885-js","indicatorsop-indicatorsop-module":"indicatorsop-indicatorsop-module","indicatortest-indicatortest-module":"indicatortest-indicatortest-module","klinechart-klinechart-module":"klinechart-klinechart-module","klineconfig-klineconfig-module":"klineconfig-klineconfig-module","klineconfigop-klineconfigop-module":"klineconfigop-klineconfigop-module","login-login-module":"login-login-module","loginhistory-loginhistory-module":"loginhistory-loginhistory-module","mstock-apiconfig-apiconfig-module":"mstock-apiconfig-apiconfig-module","mstock-apiconfigop-apiconfigop-module":"mstock-apiconfigop-apiconfigop-module","mstock-mstockbalance-mstockbalance-module":"mstock-mstockbalance-mstockbalance-module","mstock-mstockcoordinatorop-mstockcoordinatorop-module":"mstock-mstockcoordinatorop-mstockcoordinatorop-module","mstock-mstockposition-mstockposition-module":"mstock-mstockposition-mstockposition-module","mstock-mstockruleop-mstockruleop-module":"mstock-mstockruleop-mstockruleop-module","mstock-mstockrules-mstockrules-module":"mstock-mstockrules-mstockrules-module","mstock-mstocktemplate-mstocktemplate-module":"mstock-mstocktemplate-mstocktemplate-module","mstock-mstocktemplateop-mstocktemplateop-module":"mstock-mstocktemplateop-mstocktemplateop-module","mstock-productlist-productlist-module":"mstock-productlist-productlist-module","mstock-productop-productop-module":"mstock-productop-productop-module","orderlist-orderlist-module":"orderlist-orderlist-module","sfhedgingruleop-sfhedgingruleop-module":"sfhedgingruleop-sfhedgingruleop-module","sfhedgings-sfhedgings-module":"sfhedgings-sfhedgings-module","sfhedgingtemplate-sfhedgingtemplate-module":"sfhedgingtemplate-sfhedgingtemplate-module","sfhedgingtemplateop-sfhedgingtemplateop-module":"sfhedgingtemplateop-sfhedgingtemplateop-module","sfprice-sfprice-module":"sfprice-sfprice-module","shadow-css-4889ae62-23996f3f-js":"shadow-css-4889ae62-23996f3f-js","shedgingruleop-shedgingruleop-module":"shedgingruleop-shedgingruleop-module","shedgings-shedgings-module":"shedgings-shedgings-module","shedgingtemplate-shedgingtemplate-module":"shedgingtemplate-shedgingtemplate-module","shedgingtemplateop-shedgingtemplateop-module":"shedgingtemplateop-shedgingtemplateop-module","spotcoordinatorop-spotcoordinatorop-module":"spotcoordinatorop-spotcoordinatorop-module","spotexchangeposition-spotexchangeposition-module":"spotexchangeposition-spotexchangeposition-module","spotposition-spotposition-module":"spotposition-spotposition-module","spotruleop-spotruleop-module":"spotruleop-spotruleop-module","spots-spots-module":"spots-spots-module","spottemplate-spottemplate-module":"spottemplate-spottemplate-module","spottemplateop-spottemplateop-module":"spottemplateop-spottemplateop-module","sprice-sprice-module":"sprice-sprice-module","starttest-starttest-module":"starttest-starttest-module","tabs-tabs-module":"tabs-tabs-module","tprice-tprice-module":"tprice-tprice-module","triangularop-triangularop-module":"triangularop-triangularop-module","triangulars-triangulars-module":"triangulars-triangulars-module","triangulartemplate-triangulartemplate-module":"triangulartemplate-triangulartemplate-module","triangulartemplateop-triangulartemplateop-module":"triangulartemplateop-triangulartemplateop-module","swiper-bundle-ccdaac54-js":"swiper-bundle-ccdaac54-js","ios-transition-836e46fb-js":"ios-transition-836e46fb-js","md-transition-5091809d-js":"md-transition-5091809d-js","swipe-back-35ad8e37-js":"swipe-back-35ad8e37-js","focus-visible-70713a0c-js":"focus-visible-70713a0c-js","hardware-back-button-5afe3cb0-js":"hardware-back-button-5afe3cb0-js","input-shims-a4fc53ac-js":"input-shims-a4fc53ac-js","status-tap-a0df8284-js":"status-tap-a0df8284-js","tap-click-ca00ce7f-js":"tap-click-ca00ce7f-js","board-board-module":"board-board-module","indicators-indicators-module":"indicators-indicators-module","myconfig-myconfig-module":"myconfig-myconfig-module","report-report-module":"report-report-module","tpl-tpl-module":"tpl-tpl-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
